import axios from 'axios'

import { authorizationHeaderInterceptor } from './configureInterceptors'

const ApiName = {
  MARKETSTATUS: 'market_statuses',
  COMPLIANCE: 'compliance'
}

class MsApiClient {
  constructor() {
    const { VITE_APP_URL_MS } = import.meta.env

    this.apiClient = axios.create({
      baseURL: `${VITE_APP_URL_MS}`
    })

    authorizationHeaderInterceptor(this.apiClient.interceptors.request)
  }

  get(apiName, resource, params = {}, additionalHeaders = {}, responseType = 'json') {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.get(endpoint, {
      params: params,
      headers: { ...additionalHeaders },
      responseType: responseType
    })
  }

  post(apiName, resource, data, additionalHeaders = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.post(endpoint, data, {
      headers: { ...additionalHeaders }
    })
  }

  patch(apiName, resource, data, additionalHeaders = {}) {
    const endpoint = resource ? `/${apiName}/${resource}` : `/${apiName}`
    return this.apiClient.patch(endpoint, data, {
      headers: { ...additionalHeaders }
    })
  }

  put(apiName, id, data) {
    const endpoint = id ? `/${apiName}/${id}` : `/${apiName}`
    return this.apiClient.put(endpoint, data)
  }

  delete(apiName, id) {
    const endpoint = `/${apiName}/${id}`
    return this.apiClient.delete(endpoint)
  }
}

const msApiClient = new MsApiClient()

export const fetchMaintenance = () => {
  return msApiClient.get(ApiName.MARKETSTATUS, `maintenance`)
}

export const checkCompliance = (type, queryParams = {}) => {
  return msApiClient.get(ApiName.COMPLIANCE, `${type}/check`, queryParams)
}
